import { render } from "./UnavailablePage.vue?vue&type=template&id=337486a4&scoped=true&ts=true"
import script from "./UnavailablePage.vue?vue&type=script&lang=ts"
export * from "./UnavailablePage.vue?vue&type=script&lang=ts"

import "./UnavailablePage.vue?vue&type=style&index=0&id=337486a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337486a4"]])

export default __exports__